import { QueryClient } from "@tanstack/react-query";

/** Shared query client. Conservative defaults — analytics is pollable, not chatty. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
